import { AnalyticsWindow } from "./analytics-window"
import { appendValuesToUserProperty } from "./analytics-identify"

declare let window: AnalyticsWindow

interface OptimizelyState {
  id: string
  campaignName: string
  isInCampaignHoldback: boolean
  experiment: {
    id: string
    name: string
  }
  variation: {
    id: string
    name: string
  }
}

interface OptimizelyData {
  "Is Optimizely active"?: boolean
  "Optimizely experiments"?: string[]
  "Optimizely variations"?: string[]
}

function getOptimizelyData(): OptimizelyData {
  if (!window.optimizely.get) {
    return {}
  }

  const activeCampaignStates: OptimizelyState[] = Object.values(
    window.optimizely.get("state").getCampaignStates({ isActive: true }),
  )

  const isActive = activeCampaignStates.length > 0

  const experiments = activeCampaignStates.map(state =>
    state.experiment.name === state.campaignName
      ? state.experiment.name
      : `${state.campaignName} - ${state.experiment.name}`,
  )

  const variations = activeCampaignStates.map(state => {
    const experimentName =
      state.experiment.name === state.campaignName
        ? state.experiment.name
        : `${state.campaignName} - ${state.experiment.name}`
    return `${experimentName} - ${state.variation.name} ${state.isInCampaignHoldback ? "- holdback" : ""}`
  })

  const baseResult = {
    "Is Optimizely active": isActive,
  }

  return isActive
    ? {
        ...baseResult,
        "Optimizely experiments": experiments,
        "Optimizely variations": variations,
      }
    : baseResult
}

function sendEventToOptimizely(
  eventName: string,
  additionalProperties: Record<string, any> = {},
) {
  if (window.optimizely.get) {
    window["optimizely"].push({
      type: "event",
      eventName: eventName,
      properties: {
        "Page url": window.location.href,
        "Page path": window.location.pathname,
        ...additionalProperties,
      },
    })
  }
}

export { sendEventToOptimizely }
export default getOptimizelyData
